import createIcon from '../../createIcon';

/**
 * @component @name ScreenShare
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMThDMjEuMSAxOCAyMS45OSAxNy4xIDIxLjk5IDE2TDIyIDZDMjIgNC44OSAyMS4xIDQgMjAgNEg0QzIuODkgNCAyIDQuODkgMiA2VjE2QzIgMTcuMSAyLjg5IDE4IDQgMThIMFYyMEgyNFYxOEgyMFpNMTMgMTQuNDdWMTIuMjhDMTAuMjIgMTIuMjggOC4zOSAxMy4xMyA3IDE1QzcuNTYgMTIuMzMgOS4xMSA5LjY3IDEzIDkuMTNWN0wxNyAxMC43M0wxMyAxNC40N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScreenShare = createIcon('ScreenShare', [
  [
    'path',
    {
      d: 'M20 18C21.1 18 21.99 17.1 21.99 16L22 6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V16C2 17.1 2.89 18 4 18H0V20H24V18H20ZM13 14.47V12.28C10.22 12.28 8.39 13.13 7 15C7.56 12.33 9.11 9.67 13 9.13V7L17 10.73L13 14.47Z',
      key: 'a634c2',
    },
  ],
]);

export default ScreenShare;
